import compose from 'lodash/fp/compose'
import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'

export function getNames(email: string): [string, string] {
  return compose(
    (list: string[]) => {
      if (!list || list.length < 2) throw new Error('Incorrect email format')
      if (!list || list.length > 2) return [list.slice(0, 1), list.slice(1).join(' ')]
      return list
    },
    (list: string[]) => list.map(capitalizeFirstLetter),
    (list: string[] | undefined) => {
      if (!list) throw new Error('Incorrect email format')
      return list
    },
    ([name]) => name.split('.'),
    (value) => value.split('@'),
  )(email)
}